import React, { useState, useRef } from "react";
import { Box, Form, Alert, Button, Input } from "@intech/web-ui";
import { UsuarioService } from "@services";
import { LoginEntidade } from "@entidades";
import { MasterPage } from "@components";

export const TrocarSenha: React.FC = ({ ...rest }) => {
  const [mensagem, setMensagem] = useState("");
  const [Erros, setErros] = useState(null);

  const [senhaAtual, setSenhaAtual] = useState("");
  const [senhaNova, setSenhaNova] = useState("");
  const [senhaNovaConfirma, setSenhaNovaConfirma] = useState("");

  const form = useRef<Form>(null);

  // useEffect(() => {
  //   (async () => {
  //     await criarLog(DMN_FUNCIONALIDADE.TROCAR_SENHA);
  //   })();
  // }, []);

  async function trocarSenha() {
    try {
      setErros("");

      const erros = await form?.current?.validate();

      if (erros) {
        setErros(erros);
        return;
      }

      setMensagem("");

      if (senhaNova.length < 8) {
        setErros("A senha deve conter pelo menos 8 caracteres, um número (0-9), uma letra minúscula e maiúscula (a-z, A-Z) e um caracter especial.");
        return;
      }

      const data = new LoginEntidade();
      data.SenhaAtual = senhaAtual;
      data.SenhaNova = senhaNova;
      data.SenhaNovaConfirma = senhaNovaConfirma;

      const resultado = await UsuarioService.AlterarSenha(data);
      setMensagem(resultado);
    } catch (e) {
      const err: any = e;
      const message = err.response ? err.response.data : err;
      setErros(message);
    }
  }

  return (
    <MasterPage {...rest}>
      <Box>
        <Form ref={form}>
          <Input title={"Senha Atual"} value={senhaAtual} onChange={setSenhaAtual} type={"password"} required />

          <Input title={"Nova Senha"} value={senhaNova} onChange={setSenhaNova} type={"password"} required />

          <Input title={"Confirme nova senha"} value={senhaNovaConfirma} onChange={setSenhaNovaConfirma} type={"password"} required />

          {mensagem && <Alert type={"info"}>{mensagem}</Alert>}

          <Alert type={"danger"}>{Erros}</Alert>
          <hr />

          <Button title={"Trocar Senha"} type={"primary"} onClick={trocarSenha} submit usesLoading loadingText={"Carregando..."} />
        </Form>
      </Box>
    </MasterPage>
  );
};
